import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers } from '@fortawesome/free-solid-svg-icons'


const ListStat = ({span, text, color}) => {
  return (<div className='d-flex  align-items-center'>
    <FontAwesomeIcon className={`text-${color} fs-2 mx-2 mx-md-4`} icon={faUsers} /> 
    <p style={{fontSize: "calc(1vw + 12px)"}} className=''><span className={`text-${color} fw-bold`}>{span}</span>{text}</p>
  </div>)
}

export default ListStat